<template>
  <div v-if="isShowPage" class="login">
    <guide class="guide" />
    <nav-bar :title="lang.loginLang" class="nav-bars" :showType="'text'"></nav-bar>
    <!-- <button @click="test">测试</button> -->
    <div class="login_wap login_pc">
      <!-- pc端logo显示 -->
      <p class="login_pc_title">
        <img src="../../assets/logo.png" alt="" />
      </p>
      <!-- wap端logo显示 -->
      <img src="//uatstatic.house730.com.cn/m/images/icon.png" alt="" class="login_wap_img" />
      <!-- tab切换 -->
      <van-tabs v-model="tabLogin" title-active-color="#ed1c24" @click="cutoverTab" :line-width="110" title-inactive-color="#333">
        <!-- 快捷登入 -->
        <van-tab :title="lang.fastLoginLang">
          <house-form :type="'login'" :active="1" :model="model" ref="form" class="login_pc_form login_wap_form" :error="error">
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <!-- 待开放 -->
              <house-select :options="options" v-model="model.check" placeholder="852"></house-select>
              <house-input
                :noPast="true"
                type="text"
                v-model.trim="model.telephone"
                :placeholder="lang.telPointLang"
                @del="delModel('telephone')"
                :delBtn="model.telephone"
              ></house-input>
            </house-form-item>
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <house-input :noPast="true" type="text" v-model.trim="model.code" :placeholder="lang.SMSPointLang" @keyupEnter="fastLogin"></house-input>
              <houseCode @end="endBackword" @click="sendCode" :error="error" :userInput="model"></houseCode>
            </house-form-item>
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <!-- 新闻接收邮箱 存在禁止修改 -->
              <house-input
                :noPast="true"
                :editDisable="editDisable"
                type="text"
                v-model.trim="model.subscribeEmail"
                :placeholder="lang.newsPointLang"
                @del="delModel('subscribeEmail')"
                :delBtn="model.subscribeEmail"
              ></house-input>
            </house-form-item>
            <div class="login_wap_agree">
              <house-agree v-model="model.agree"
                ><span class="agree_info">{{ lang.agreeLang }}</span> <a :href="helpConfig+lang.tremsUrl">{{ lang.house730Lang }}</a></house-agree
              >
            </div>
            <div class="conCheckboxList" v-if="subscribeTo">
              <house-agree v-model="model.subscribeEmailStatus"></house-agree>
              <div class="sub_tit" @click="changeSubStatus">{{ lang.subtit }}</div>
            </div>
          </house-form>

          <div class="red_btn" @click="fastLogin" :class="fastLightBtn ? 'red_active' : ''">{{ lang.loginLang }}</div>
          <!-- <p class="school_btn" @click="goSchool">{{ lang.schoolLang }}</p> -->
        </van-tab>
        <!-- 賬號密碼登入 -->
        <van-tab :title="lang.userLoginLang">
          <!-- 切换登入方式 -->
          <div class="cut_pc_btn" @click="checkPcLogin">{{ loginType == 'email' ? lang.telLang : lang.emailLang }}</div>
          <house-form :type="'login'" :active="2" :model="loginList" ref="form" :error="error" class="login_pc_form login_wap_form">
            <house-form-item v-show="loginType == 'email'" class="login_pc_form_item login_wap_form_item">
              <house-input v-model.trim="loginList.email" :placeholder="lang.emailPointLang" @del="delLoginList('email')" :delBtn="loginList.email" @blur="hasPassword('Email')"></house-input>
              <span class="blue_btn cut_btn" @click="checkLogin('tel')">{{ lang.telLang }}</span>
            </house-form-item>
            <house-form-item v-show="loginType == 'tel'" class="login_pc_form_item login_wap_form_item">
              <house-select :options="options" v-model="loginList.check" placeholder="852"></house-select>
              <house-input
                type="text"
                v-model.trim="loginList.telephone"
                :placeholder="lang.telPointLang"
                @del="delLoginList('telephone')"
                :delBtn="loginList.telephone"
                @blur="hasPassword('Phone')"
              ></house-input>
              <span class="blue_btn cut_btn" @click="checkLogin('email')">{{ lang.emailLang }}</span>
            </house-form-item>
            <!-- end -->
            <house-form-item class="login_pc_form_item login_wap_form_item">
              <house-input :type="eyeType" v-model.trim="loginList.password" :placeholder="lang.passwordPointLang" @keyupEnter="loginBtn"></house-input>
              <svg class="icon icon_eye" aria-hidden="true" @click="eyeOpen">
                <use :xlink:href="eyeSvg"></use>
              </svg>
            </house-form-item>
            <house-form-item v-show="imgValidatorOpen" class="login_pc_form_item login_wap_form_item">
              <house-input type="text" v-model.trim="verifyCode" :placeholder="lang.ImgPointLang" maxlength="4" @keyupEnter="loginBtn"></house-input>
              <img :src="verifyImg" alt="" class="verifyImg" @click="loadImg" />
            </house-form-item>
            <div class="login_pc_remember">
              <!-- <house-agree v-model="loginList.remember">記住密碼</house-agree> -->
              <span @click="goForget">{{ lang.forgetPasswordLang }}</span>
            </div>
          </house-form>
          <div class="red_btn" :class="lightBtn ? 'red_active' : ''" @click="loginBtn">{{ lang.loginLang }}</div>
          <div class="login_pc_forget">
            <!-- <p class="school_btn" @click="goSchool">{{ lang.schoolLang }}</p> -->
          </div>
          <div class="login_wap_forget_case">
            <div class="login_wap_forget">
              <div class="write_btn" @click="goForget">{{ lang.forgetPasswordLang }}</div>
              <!-- <p class="school_btn" @click="goSchool">{{ lang.schoolLang }}</p> -->
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- agree弹出层 -->
    <van-dialog v-model="agreeShow" class="agree_case" :confirmButtonText="lang.continueLang">
      <div class="agree_content">{{ lang.agreeNoticeLang }}</div>
    </van-dialog>
  </div>
</template>

<script>
import houseForm from '../../components/houseLogin/houseForm';
import houseFormItem from '../../components/houseLogin/houseFormItem.vue';
import houseInput from '../../components/houseLogin/houseInput.vue';
import houseSelect from '../../components/houseLogin/houseSelect.vue';
import houseCode from '../../components/houseLogin/houseCode.vue';
import houseAgree from '../../components/houseLogin/houseAgree.vue';
import guide from '../../components/guide';
import navBar from '../../components/navBar';
import pub from '../../../common/public';
import lang from '../../../common/language/new_login';
const _conf = require('../../../common/js/_conf');
export default {
  created() {
    this.helpConfig = _conf.env_type == 3 ?'https://m.house730.com': _conf.env_type == 4?'https://simm.house730.com':'https://uatm.house730.com.cn'
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    this.$route.query && this.$route.query.referrer ? (this.backUrl = this.$route.query.referrer) : (this.backUrl = '/');
    this.$route.query && this.$route.query.tab == 1 ? (this.tabLogin = 1) : (this.tabLogin = 0);
  },
  mounted() {
    dataLayer.unshift({
      event: 'pageview',
      source: 'LIP',
      target: '',
      user: {
        language: `${window._language}`, // ie ‘zh-hk’
        id: '', // ie ‘41121’
      },
    });
    // console.log('dataLayer', window.dataLayer);
  },
  data() {
    return {
      helpConfig:'',
      subscribeTo: true,
      isShowPage: true,
      agreeShow: false,
      backUrl: '/',
      lang: lang,
      //同意条款
      // model: {
      //   telephone: '',
      //   code: '',
      //   check: '852',
      //   agree: '',
      // },
      model: {
        telephone: '',
        code: '',
        check: '852',
        agree: '',
        subscribeEmail: '',
        subscribeEmailStatus: true,
      },
      editDisable: false,
      //登入数据
      loginList: {
        telephone: '',
        code: '',
        password: '',
        check: '852',
        email: '',
      },
      error: '', //报错信息
      switchCode: true, //验证码开关
      lightCode: false, //动态检验
      loginType: 'tel', //切换登入方式
      eyeType: 'password', //密码显示隐藏
      eyeSvg: '#icon-yincangmima', //密码icon
      imgValidatorOpen: false, //图片验证
      isfirstlogin: false,
      tabLogin: 0, //切换登入類型,
      verifyImg: '', //验证图形
      verifyCode: '', //图形验证码
      verifyToken: '', //图形验证token
      options: [
        { name: '853', id: '1' },
        { name: '852', id: '2' },
        { name: '86', id: '3' },
      ],
      isPc: false,
    };
  },
  methods: {
    changeSubStatus() {
      this.model.subscribeEmailStatus = !this.model.subscribeEmailStatus;
    },
    test() {
      // this.$router.push('/');
    },
    /*——————公共方法——————*/
    /*登入/教学*/
    goSchool() {
      // if (document.body.clientWidth > 600) {
      //   window.location.href = 'https://promotion.house730.com/newuser_pc/';
      // } else {
      //   window.location.href = 'https://promotion.house730.com/newuser_app/';
      // }
      this.$router.push('/school');
    },
    /* 清空输入框*/
    delModel(type) {
      this.model[type] = '';
      if (type == 'telephone') {
        this.model.subscribeEmail = '';
        this.editDisable = false;
        this.subscribeTo = true;
        this.model.subscribeEmailStatus = true;
      }
    },
    delLoginList(type) {
      this.loginList[type] = '';
    },
    /* 重置表单 */
    resetForm() {
      this.model = {
        telephone: '',
        code: '',
        check: '852',
        agree: '',
        subscribeEmail: '',
        subscribeEmailStatus: true,
      };
      //登入数据
      this.loginList = {
        telephone: '',
        password: '',
        check: '852',
        email: '',
      };
      this.verifyCode = '';
      this.verifyToken = '';
      this.eyeType = 'password';
      this.eyeSvg = '#icon-yincangmima';
      this.error = '';
      this.imgValidatorOpen = false;
      this.subscribeTo = true
    },
    /* 抬头切换 */
    cutoverTab() {
      this.resetForm();
    },
    /* 验证码倒数回调 */
    endBackword(type) {
      console.log(type);
      // this.switchCode = type;
      this.error = type;
    },
    /* 前往忘記密碼 */
    goForget() {
      this.$router.push('/forget');
    },
    /*返回登入前页面方法*/
    pushUrl() {
      const curLang = window._language === 'en-us' ? 'en-us/' : window._language === 'zh-hk' ? '' : 'zh-cn/';
      /**添加手册登录判断 */
      const isFirstLog = this.isfirstlogin ? '?isfirstlogin=true' : '';
      if (this.isfirstlogin) this.pub.setCookie('isfirstlogin', '1');
      let referrer = this.$route.query.referer || this.$route.query.referrer || '';
      referrer = referrer.replace('isfirstlogin', 'fst');
      referrer && referrer.indexOf('account') > -1 ? (referrer = null) : '';
      if (!referrer) {
        console.log("??!!!!!",this.helpConfig +"/my/" + isFirstLog)
        document.body.clientWidth > 700 ? (location.href = this.pub.config.pcPassport + curLang + isFirstLog) : (location.href = this.helpConfig +"/my/" + isFirstLog) ;
        // document.body.clientWidth > 700 ? (location.href = this.pub.config.pcPassport + curLang + isFirstLog) : this.$router.push('/' + isFirstLog);
      } else {
        if (document.referrer && referrer && document.referrer.indexOf('/login') == -1) {
          // document.body.clientWidth > 700 ? (location.href = referrer + isFirstLog) : history.back(-1)
          // liu 0824 修改
          if (document.body.clientWidth > 700) {
            location.href = referrer + isFirstLog;
          } else {
            location.href = referrer + isFirstLog;
            // // history.back(-1)

            /**
             * 老版本浏览历史页单独处理跳转(原因:未知)
             * */ 
            // 樓盤收藏走的
            // if (referrer.indexOf('/history') == -1) {
            //   location.href = referrer + isFirstLog;
            // } else {
            //   location.href = `/my` + curLang + referrer + isFirstLog;
            // }
          }
        } else if (this.$route.query.url) {
          location.href = referrer + `&url=${this.$route.query.url}&isfirstlogin=true`;
        } else {
          /**正常跳转 */
          location.href = referrer + isFirstLog;
        }
      }
    },
    /* 登入埋点 */
    setLoginGio(userID, userType) {
      gio('setUserId', userID);
      // 登录成功埋点
      /** page_name  暂时写死*/
      gio('track', 'login_success', {
        login_user_id: userID,
        page_name: '登錄頁',
      });
      gio('people.set', {
        logintype: userType,
      });
    },
    /*——————快捷驗證登入——————*/

    /* 点击验证码按钮 */
    sendCode(error) {
      this.error = error;
    },

    /* 点击登入 */
    fastLogin() {
      // let { telephone, agree, code } = this.model;
      let { telephone, agree, code, subscribeEmail, subscribeEmailStatus } = this.model;
      if (!this.fastLightBtn || this.error) return;
      if (!agree) {
        this.agreeShow = true;
        return;
      }
      // console.log(111111111);
      this.axios
        .post(pub.getApi().LoginByCaptcha, {
          type: 'Captcha',
          phoneCode: '852',
          account: telephone,
          smsCaptcha: code,

          subscribeEmail: subscribeEmail,
          subscribeEmailStatus: subscribeEmailStatus,
        })
        .then((res) => {
          console.log('快捷登入', res);
          if (res.data.code == 0) {
            // console.log("res.data.result.userID",res.data.result.userID)
            console.log('登入成功！');
            /**记录是否是第一次登录 */
            this.isfirstlogin = res.data.result.isFirstLogin;
            if (this.isfirstlogin) {
              dataLayer.push({
                event: 'userSignup',
                source: 'LIP',
                target: '',
                user: {
                  language: `${window._language}`, // ie ‘zh-hk’
                  id: `${res.data.result.userID}`, // ie ‘41121’
                },
              });
            } else {
              dataLayer.push({
                event: 'userLogin',
                source: 'LIP',
                target: '',
                user: {
                  language: `${window._language}`, // ie ‘zh-hk’
                  id: `${res.data.result.userID}`, // ie ‘41121’
                },
              });
            }
            const userInfo = JSON.stringify({
              userId: res.data.result.userID,
              nickName: res.data.result.nickName,
            });
            //查询用户类型
            this.axios(pub.getApi().GetUserInfo, {
              params: {
                token: res.data.result.token,
              },
            }).then((resUser) => {
              this.setLoginGio(res.data.result.userID, resUser.data.result && resUser.data.result.isPropertyAgent ? '代理人' : '普通用戶');
            });
            pub.setCookie('ERnJaMWtkM',escape(userInfo),res.data.result.expirationTime); // 写入用户编号
            pub.setCookie('cEVaUDFrZ1kd0RA',res.data.result.token,res.data.result.expirationTime); // 写入token
            console.log(99, document.referrer);
            sessionStorage.setItem('hsasLogin', document.referrer);
            this.pushUrl();
            // if (this.backUrl != '/') {
            //   window.location.href = this.backUrl;
            // } else {
            //   this.$router.push('/');
            // }
          } else {
            this.error = this.lang.SMSErrorLang;
          }
        });
      // console.log('点击登入');
    },
    // 注册 失去焦点获取订阅电邮
    hasSubEmail() {
      if (this.modelTel && !this.error) {
        this.axios
          .get(pub.getApi().GetUserSubscribeEmailByPhone, {
            params: {
              phone: this.modelTel,
            },
          })
          .then((res) => {
            if (res.data.code == 0 && res.data.result) {
              if (res.data.result.subscribeEmail) {
                this.model.subscribeEmail = res.data.result.subscribeEmail;
                this.editDisable = true;
              } else {
                this.model.subscribeEmail = '';
                this.editDisable = false;
              }
              if(res.data.result.subscribeEmailStatus) {
                this.subscribeTo = !res.data.result.subscribeEmailStatus;
                this.model.subscribeEmailStatus = true;
              } else {
                this.subscribeTo = !res.data.result.subscribeEmailStatus;
                this.model.subscribeEmailStatus = false;
              }
            } else {
              this.editDisable = false;
              this.model.subscribeEmail = '';
              this.model.subscribeEmailStatus = true;
            }
          });
      } else if (this.modelTel == '') {
        // 针对手动删除电话
        this.model.subscribeEmail = '';
        this.editDisable = false;
        // this.model.subscribeEmailStatus = true;
      }
    },
    /*——————賬號密碼登入——————*/
    /*失去焦点获取密码*/
    hasPassword(type) {
      if ((this.loginListTel || this.loginListEmail) && !this.error) {
        this.axios
          .post(pub.getApi().IsAllowPasswordLogin, {
            type: type,
            phoneCode: type == 'Phone' ? '852' : null,
            account: type == 'Phone' ? this.loginListTel : this.loginListEmail,
          })
          .then((res) => {
            let have = res.data.result;
            if (have || this.tabLogin == 0) {
              this.error = '';
            } else {
              this.error = this.lang.hasPasswordLang;
            }
          });
      }
    },
    /* pc端改版电话、邮箱登入切换方式 */
    checkPcLogin() {
      this.loginType == 'email' ? (this.loginType = 'tel') : (this.loginType = 'email');
      console.log('切换');
    },
    /* 电话、邮箱登入切换方式 */
    checkLogin(type) {
      this.loginType = type;
      this.resetForm();
    },

    /* 账号密码登入按钮 */
    loginBtn() {
      let { telephone, password, check, email } = this.loginList;
      if (this.loginType == 'tel') {
        if (telephone.length == 0 || password.length == 0 || this.error) return;
        // console.log(11111111);
        let telResult = this.pub.telValidator(telephone, check);
        let pdResult = this.pub.passwordValidator(password);
        if (telResult == 1 || telResult == 2) {
          this.error = this.lang.errTelFormLang;
        } else if (pdResult == 1) {
          this.error = this.lang.errPasswordFormLang;
        } else {
          this.error = '';
          this.loginApi(telephone, password, check, 'phone', this.verifyCode, this.verifyToken);
        }
      } else {
        if (email.length == 0 || password.length == 0 || this.error) return;
        // console.log(1111111);
        let emResult = this.pub.emailValidator(email);
        let pdResult = this.pub.passwordValidator(password);
        if (emResult == 1) {
          this.error = this.lang.errEmailFormLang;
        } else if (pdResult == 1) {
          this.error = this.lang.errPasswordFormLang;
        } else {
          this.error = '';
          this.loginApi(email, password, '', 'email', this.verifyCode, this.verifyToken);
        }
      }
    },
    /* 登入接口 */
    loginApi(account, password, code = '', type = 'phone', verifyCode = '', verifyToken = '') {
      this.axios
        .post(
          this.pub.getApi().LoginByPassword,
          {
            type: type,
            code: code,
            account: account,
            password: password,
          },
          {
            params: {
              'h-recaptchavalue': verifyCode,
              'h-recaptcha': verifyToken,
            },
          }
        )
        .then((res) => {
          console.log('登入结果', res);
          if (res.data.code == 0) {
            dataLayer.push({
              event: 'userLogin',
              source: 'LIP',
              target: '',
              user: {
                language: `${window._language}`, // ie ‘zh-hk’
                id: `${res.data.result.userID}`, // ie ‘41121’
              },
            });
            // console.log("mima登入",window.dataLayer)

            // console.log("res.data.result.userID",res.data.result.userID)
            console.log('登入成功！');
            if (this.isPc) {
              if (pub.getLang() === 'zh-cn') {
                location.href = `${pub.config.pcUrl}zh-cn/help/memberlogin/`;
              } else if (pub.getLang() === 'en-us') {
                location.href = `${pub.config.pcUrl}en-us/help/memberlogin/`;
              } else {
                location.href = `${pub.config.pcUrl}help/memberlogin/`;
              }
            }
            this.isfirstlogin = res.data.result.isFirstLogin;
            this.imgValidatorOpen = false;
            this.resetForm();
            const userInfo = JSON.stringify({
              userId: res.data.result.userID,
              nickName: res.data.result.nickName,
            });
            //查询用户类型
            this.axios(pub.getApi().GetUserInfo, {
              params: {
                token: res.data.result.token,
              },
            }).then((resUser) => {
              this.setLoginGio(res.data.result.userID, resUser.data.result && resUser.data.result.isPropertyAgent ? '代理人' : '普通用户');
            });
            pub.setCookie('ERnJaMWtkM',escape(userInfo),res.data.result.expirationTime); // 写入用户编号
            pub.setCookie('cEVaUDFrZ1kd0RA',res.data.result.token,res.data.result.expirationTime);
            sessionStorage.setItem('hsasLogin', document.referrer);
            this.pushUrl();
            // if (this.backUrl != '/') {
            //   window.location.href = this.backUrl;
            // } else {
            //   this.$router.push('/');
            // }
          } else if (res.data.code == 101) {
            this.loadImg();
            if (this.imgValidatorOpen) {
              this.error = this.lang.SMSErrorLang;
            }
            this.imgValidatorOpen = true;
          } else if (res.data.code == 1310) {
            console.log('错误1301');
            this.imgValidatorOpen = false;
            this.verifyCode = '';
            this.error = this.lang.errMaxLang;
          } else {
            console.log('错误1300');
            this.error = this.lang.errAllLang;
            if (this.imgValidatorOpen) {
              this.loadImg();
            }
          }
        });
    },
    /* 密码显示隐藏 */
    eyeOpen() {
      this.eyeType == 'password' ? (this.eyeType = 'text') : (this.eyeType = 'password');
      this.eyeSvg == '#icon-yincangmima' ? (this.eyeSvg = '#icon-xianshimima') : (this.eyeSvg = '#icon-yincangmima');
    },
    /* 图片验证码 */
    loadImg() {
      this.axios(pub.getApi().GetRecaptcha).then((res) => {
        console.log('图片', res);
        if (res.data.code === 0) {
          this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
          this.verifyToken = res.data.result.token;
        }
      });
    },
    /* 给cookie修改为180天时效 */
    setCookieTo(name, value, timestamp) {
      var date = new Date(timestamp * 1000);
      date.setTime(date.getTime() + 2 * 60 * 1000);
      var expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
    }
  },
  watch: {
    'model.telephone': {
      handler() {
        let result = pub.telValidator(this.modelTel);
        if (this.modelTel && result == 2) {
          this.error = this.lang.errTelFormLang;
        } else {
          this.error = '';
        this.hasSubEmail('Email');
        this.subscribeTo = true;
        }
      },
      deep: true,
    },

    'model.subscribeEmail': {
      handler() {
        let resultEmail = pub.emailValidator(this.modelEmail);
        if (this.modelEmail && resultEmail != 0) {
          this.error = this.lang.errEmailFormLang;
        } else {
          this.error = '';
        }
      },
      deep: true,
    },
    // model: {
    //   handler() {
    //     let result = pub.telValidator(this.modelTel);
    //     let resultEmail = pub.emailValidator(this.modelEmail);
    //     if (this.modelTel && result == 2) {
    //       this.error = this.lang.errTelFormLang;
    //     } else {
    //       this.error = '';
    //     }
    //     if (this.modelEmail && resultEmail != 0) {
    //       this.error = this.lang.errEmailFormLang;
    //     } else {
    //       this.error = '';
    //     }
    //   },
    //   deep: true,
    // },
    loginList: {
      handler() {
        let resultTel = pub.telValidator(this.loginListTel);
        let resultEmail = pub.emailValidator(this.loginListEmail);
        if (this.loginListTel && resultTel != 0 && this.loginType == 'tel') {
          switch (resultTel) {
            case 1:
              this.error = this.lang.errTelLang;
              break;
            case 2:
              this.error = this.lang.errTelFormLang;
              break;
          }
        } else if (this.loginListEmail && resultEmail != 0 && this.loginType == 'email') {
          this.error = this.lang.errEmailFormLang;
        } else {
          this.error = '';
        }
      },
      deep: true,
    },
    verifyCode(value) {
      let reg = /^\d{4}$/;
      if (reg.test(value)) this.error = '';
    },
  },
  computed: {
    /* 账号密码登入按钮高亮 */
    lightBtn() {
      let { telephone, email, password } = this.loginList;
      return (telephone.length > 0 || email.length > 0) && password.length > 0 ? true : false;
    },
    /* 快捷登入按钮高亮 */
    fastLightBtn() {
      let { telephone, code, subscribeEmail } = this.model;
      if (telephone.length > 0 && code.length > 0 && subscribeEmail.length > 0) {
        return true;
      } else {
        return false;
      }
      // let { telephone, code } = this.model;
      // if (telephone.length > 0 && code.length > 0) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    modelTel() {
      return this.model.telephone;
    },
    modelEmail() {
      return this.model.subscribeEmail;
    },
    loginListTel() {
      return this.loginList.telephone;
    },
    loginListEmail() {
      return this.loginList.email;
    },
  },
  components: {
    houseForm,
    houseFormItem,
    houseInput,
    houseSelect,
    houseCode,
    houseAgree,
    guide,
    navBar,
  },
};
</script>
<style lang="scss" scoped>
@import url('../../assets/base.css');
.login {
  width: 100%;
  height: 100%;
  overflow: auto;
  .cut_pc_btn {
    display: none;
  }

  .mt30 {
    margin-top: 30px;
  }
  .red_btn {
    cursor: pointer;
    padding: 15px;
    color: #fff;
    font-size: 17px;
    background-color: #f6afb4;
    margin-top: 51px;
  }
  .write_btn {
    cursor: pointer;

    padding: 15px;
    color: #b4b4b4;
  }
  .school_btn {
    cursor: pointer;

    padding: 15px;
    color: #0076ff;
  }

  .icon_eye {
    cursor: pointer;
    font-size: 30px;
    color: #b9b9b9;
  }
  .verifyImg {
    cursor: pointer;
    height: 30px;
    max-width: 120px;
  }
  .cut_btn {
    text-align: right;
    // width: 80px;
  }
  .agree_case {
    .agree_content {
      padding: 40px 20px 20px;
      line-height: 24px;
      font-size: 16px;
      color: #333;
    }
  }
  .login_wap {
    font-size: 14px;
    padding: 0px 15px;
    padding-top: 44px;
    .login_wap_img {
      width: 75px;
      height: 77px;
      margin-bottom: 24px;
    }
    .login_pc_title {
      display: none;
    }
    .login_wap_form {
      margin: 30px 0;
    }
    .login_wap_form_item {
      border-bottom: 1px solid #eee;
    }
    .login_wap_form_item:hover {
      border-bottom: 1px solid red;
    }
    .login_wap_agree {
      margin: 20px 0;
    }
    .conCheckboxList {
      text-align: left;
      position: relative;
    }
    .sub_tit {
      cursor: pointer;
      width: 91%;
      margin-left: 27px;
      display: inline-block;
      line-height: 18px;
      position: absolute;
      top: -4px;
    }
    .login_pc_remember {
      display: none;
    }
    .login_wap_forget_case {
      .login_wap_forget {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .login_pc_forget {
      display: none;
    }
    .agree {
      .agree_info {
        margin: 0 5px;
      }
      a {
        color: #0076ff;
      }
    }
  }
}
@media screen and (min-width: 601px) {
  .login {
    background-image: url('//static.house730.com/m/images/pcbg.jpg');
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-size: cover;
    .agree_case {
      width: 350px;
      .agree_content {
        padding: 40px 20px 20px;
      }
    }
    .guide {
      border: 0;
    }
    .login_wap {
      .login_wap_img {
        display: none;
      }
      .login_wap_forget_case {
        display: none;
      }
    }
    .login_pc {
      font-size: 16px;
      background-color: #fff;
      width: 500px;
      box-sizing: border-box;
      padding: 35px;
      .login_pc_title {
        display: block;
        padding-bottom: 20px;
      }
      .login_pc_form {
        margin: 40px 0 60px;
      }
      /deep/.info_err {
        // bottom: -40px;
        bottom: -55px;
        font-size: 16px;
      }
      .cut_pc_btn {
        display: block;
        padding: 5px 10px;
        position: absolute;
        top: 60px;
        right: 0px;
        font-size: 14px;
        background-color: #0076ff;
        color: #fff;
        border-radius: 5px 5px 0 0;
      }
      .cut_btn {
        display: none;
      }
      .login_pc_form_item {
        background-color: #f6f6f6;
        // border: none;
        border: 1px solid rgba(255, 255, 255, 1);
        margin-bottom: 25px;
      }
      .login_pc_form_item:hover {
        border: 1px solid #e70e1a;
      }
      .login_pc_remember {
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-bottom: 2px;
      }
      .login_pc_forget {
        display: block;
      }
    }
  }
}
</style>
